import styled from 'styled-components';

export const TableCellWrapper = styled.div<{
	_width: number;
	flex?: 'start' | 'end' | 'center';
	_margin?: string;
	_padding?: string;
	pointer?: boolean;
}>`
	width: ${({ _width }) => `${_width}px`};
	height: 100%;
	${({ _margin }) => _margin && `margin: ${_margin};`}
	${({ _padding }) => _padding && `padding: ${_padding};`}

	overflow: hidden;

	${({ theme }) => theme.typo.body.span};
	color: ${({ theme }) => theme.colors.gray.gray80_text};

	${({ theme, flex }) => (!flex || flex === 'end') && theme.common.flexEnd};
	${({ theme, flex }) => flex === 'start' && theme.common.flexStart};
	${({ theme, flex }) => flex === 'center' && theme.common.flexCenter};

	${({ theme }) => theme.common.ellipsis};

	flex-grow: 0;
	flex-shrink: 0;
	${({ pointer }) => pointer && `cursor: pointer`};
	user-select: none;

	${({ theme }) => theme.common.ellipsis}
`;

export const IdInner = styled.div`
	width: 100%;
	min-width: 64px;
	${({ theme }) => theme.common.flexStart};
`;

export const IdText = styled.div`
	flex-shrink: 1;
	width: 100%;

	& > div:first-of-type {
		${({ theme }) => theme.typo.body.p_bold};
		${({ theme }) => theme.common.ellipsis};

		& > span {
			cursor: text;
			user-select: text;
		}
	}

	& > div:last-of-type {
		${({ theme }) => theme.typo.body.span};
		${({ theme }) => theme.common.ellipsis};

		& > span {
			cursor: text;
			user-select: text;
		}
	}
`;

export const TagInner = styled.div`
	width: 100%;
	height: 100%;

	${({ theme }) => theme.common.flexStart}
	gap: 8px;
`;
